'use client';

import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'var(--font-noto-sans-jp), var(--font-geist-sans), Arial, sans-serif',
    },
    palette: {
        primary: {
            main: '#132c4b', // BRAND_COLOR
        },
        secondary: {
            main: '#F15859', // ACCENT_COLOR (Rose 600)
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
    },
});

export default theme;
